import { render, staticRenderFns } from "./NagorikGameEdit.vue?vue&type=template&id=5150dae2&scoped=true&"
import script from "./NagorikGameEdit.vue?vue&type=script&lang=js&"
export * from "./NagorikGameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150dae2",
  null
  
)

export default component.exports